import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import EventEmitter from './EventEmitter.js'

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.sources = sources

        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        this.progress = 0
        this.isComplete = false

        this.setLoadingManager()
        this.setLoaders()
        this.startLoading()
    }

    setLoadingManager()
    {
        this.loadingManager = new THREE.LoadingManager()

        this.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) =>
        {
            const ratio = itemsTotal > 0 ? itemsLoaded / itemsTotal : 0
            this.sendProgress(Math.min(ratio * 0.95, 0.95))
        }

        this.loadingManager.onError = (url) =>
        {
            window.parent.postMessage({ type: 'loading-error', url }, '*')
        }
    }

    setLoaders()
    {
        this.loaders = {}

        const dracoLoader = new DRACOLoader(this.loadingManager)
        dracoLoader.setDecoderPath('/draco/gltf/')
        dracoLoader.preload()

        this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
        this.loaders.gltfLoader.setDRACOLoader(dracoLoader)

        this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingManager)
    }

    startLoading()
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    },
                    undefined,
                    (error) =>
                    {
                        console.error('Error loading', source.path, error)
                        window.parent.postMessage({ type: 'loading-error', url: source.path }, '*')
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    sendProgress(ratio)
    {
        this.progress = Math.max(this.progress, ratio)
        window.parent.postMessage({ type: 'loading-progress', progress: this.progress }, '*')
    }

    sendState()
    {
        this.sendProgress(this.progress)

        if(this.isComplete)
            window.parent.postMessage({ type: 'loading-complete' }, '*')
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file
        this.trigger('sourceLoaded', [source, file])

        this.loaded++

        if(this.loaded === this.toLoad)
        {
            this.isComplete = true
            this.sendProgress(1)
            window.parent.postMessage({ type: 'loading-complete' }, '*')
            this.trigger('ready')
        }
    }
}